import styled from "styled-components"
import { AllTermsContainer, EachTermsContainer, EachTermsItems, TermsAgreeContents, TermsAgreeWrap } from "../RopForm/Terms"

export const Rop01TermsAgreeWrap = styled(TermsAgreeWrap)`
  margin: 0 auto;
  border: 1px solid #d3d7e4;
  border-left: none;
  border-right: none;
`
export const Rop01TermsAgreeContents = styled(TermsAgreeContents)``
export const Rop01AllTermsContainer = styled(AllTermsContainer)`
  margin: 10px auto 10px 10px;
  max-width: 100%;
  justify-content: center;
  font-size: 14px;
`
export const Rop01EachTermsContainer = styled(EachTermsContainer)`
  row-gap: 5px;
`
export const Rop01EachTermsItems = styled(EachTermsItems)`
  color: rgb(128, 128, 128);
`

export const TermsModalWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  // max-width: 492px 적용, pc버전에서의 크기 제한 존재.
  max-width: 492px;
  margin: auto;
  height: 100vh;
  background: rgb(0, 0, 0, 0.7);
  z-index: 1;
  display: grid;
  justify-content: center;
  align-items: center;
`
export const TermsModalBox = styled.div`
  display: grid;
  justify-content: center;
  background: white;
  width: 290px;
  padding: 30px 20px;
  gap: 20px;
`
export const TermsModalContentsBox = styled.div`
  p {
    font-size: 18px;
  }
`
export const TermsModalBtnContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 10px;
`
export const TermsModalBtn = styled.button`
  font-size: 20px;
  width: 100%;
  height: 58px;
  font-weight: bold;
`
export const TermsModalCancelBtn = styled(TermsModalBtn)`
  color: white;
`
export const TermsModalAgreeBtn = styled(TermsModalBtn)`
  background: #013e99;
  color: white;
`